import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { DatePicker, Radio, Select } from 'antd';
import { connect } from 'react-redux';

const { Option } = Select;

const DayMonthYearSelection = (props) => {
    const [currentDate, setCurrentDate] = useState(dayjs());
    const [currentTab, setCurrentTab] = useState('today');
    const [month, setMonth] = useState(dayjs().format('MMMM'));
    const [year, setYear] = useState(dayjs().year());
    const [yearList, setYearList] = useState([]);

    useEffect(() => {
        if (dayjs().year() > 2017) {
            const years = [];
            for (let i = 2017; i <= dayjs().year(); i++) {
                years.push(i);
            }
            setYearList(years.sort((a, b) => b - a));
        }
    }, []);

    const disabledDate = (current) => {
        return current && current.isAfter(dayjs().startOf('day'));
    };

    const onChange = async (dateString) => {

        const inputDate = dayjs(dateString);
        const now = dayjs();
        let endDateSelected = "";
        const startDateSelected = dayjs(dateString).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');

        if (inputDate.month() === now.month() &&
            inputDate.year() === now.year() &&
            inputDate.day() === now.day() &&
            props.selectionWidget.payload &&
            props.selectionWidget.payload.isConsiderWholeDayMonthYear === false
        ) {
            endDateSelected = dayjs().utc().format('YYYY-MM-DD HH:mm:ss');
        } else {
            endDateSelected = dayjs(dateString).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
        }

        props.selectionpayload({
            date: dayjs(dateString).utc().format('YYYY-MM-DD'),
            days: dayjs(dateString).utc().daysInMonth(),
            month: dayjs().format('MMMM'),
            startDate: startDateSelected,
            endDate: endDateSelected,
            selectionType: "DAY",
            timeZone: props.currentTimeZone,
            year: dayjs().year(),
        });

        setCurrentDate(dateString);
    };

    const onRadioChange = (e) => {
        if (e.target.value === 'month') {
            const currentMonth = dayjs().format('MMMM');
            const currentYear = dayjs().year();
            handleMenuClick(currentMonth, 'month');
            setCurrentTab(e.target.value);
            setMonth(currentMonth);
            setYear(currentYear);
        } else if (e.target.value === 'year') {
            const currentYear = dayjs().year();
            handleMenuClick(currentYear, 'year');
            setCurrentTab(e.target.value);
            setYear(currentYear);
        } else {
            onChange(dayjs());
            setCurrentTab(e.target.value);
        }
    };

    const handleMenuClick = async (value, parent) => {
        if (parent === 'month') {
            const selectedMonth = dayjs(value, 'MMMM').month();
            const currentYearVal = year;
            const isCurrentMonth = (selectedMonth === dayjs().month()) && (currentYearVal === dayjs().year());
            const startDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').startOf('month');
            let endDate;
            if (isCurrentMonth && props.selectionWidget.payload.isConsiderWholeDayMonthYear === false
            ) {
                endDate = dayjs().utc();
            } else {
                endDate = dayjs(`${currentYearVal}-${selectedMonth + 1}-01`, 'YYYY-M-D').endOf('month').utc();
            }

            props.selectionpayload({
                date: dayjs().format("YYYY-MM-DD"),
                month: value,
                year: currentYearVal,
                days: dayjs().daysInMonth(),
                startDate: startDate.utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate: endDate.format('YYYY-MM-DD HH:mm:ss'),
                selectionType: 'MONTH',
                timeZone: props.currentTimeZone,
            });

            setCurrentDate(startDate); // Update currentDate to the start of the selected month
            setMonth(value);
        } else if (parent === 'year') {
            const selectedYear = Number(value);
            const currentYear = dayjs().year();
            const startDate = dayjs(`${value}-01-01`).startOf('year');
            let endDate;

            if (selectedYear === currentYear && props.selectionWidget.payload.isConsiderWholeDayMonthYear === false) {
                endDate = dayjs().utc();
            } else {
                endDate = dayjs(`${selectedYear}-12-31`).endOf('month').utc();
            }

            props.selectionpayload({
                date: dayjs().format("YYYY-MM-DD"),
                year: selectedYear,
                days: dayjs().daysInMonth(),
                startDate: startDate.utc().format('YYYY-MM-DD HH:mm:ss'),
                endDate:  endDate.format('YYYY-MM-DD HH:mm:ss'),
                timeZone: props.currentTimeZone,
                selectionType: 'YEAR',
            });
            setCurrentDate(startDate);
            setYear(selectedYear);
        }
    };

    useEffect(() => {
        return () => {
            // Cleanup if needed
        };
    }, []);

    return (
        <div style={{ height: '70%' }}>
            <>
                <Radio.Group defaultValue={currentTab} onChange={onRadioChange} style={{ marginRight: '10px' }}>
                    <Radio.Button value="today">Daily</Radio.Button>
                    <Radio.Button value="month">Month</Radio.Button>
                    <Radio.Button value="year">Year</Radio.Button>
                </Radio.Group>
                {
                    currentTab === "today" ?
                        <DatePicker
                            onChange={onChange}
                            value={dayjs(currentDate)}
                            disabledDate={disabledDate}
                        />
                        : null
                }
                {
                    currentTab === "month" ?
                        <Select
                            value={month}
                            onChange={(e) => handleMenuClick(e, "month")}
                            style={{ width: '100px' }}
                        >
                            {
                                dayjs.months().map((value, index) => {
                                    return <Option key={index} value={value}>{value}</Option>;
                                })
                            }
                        </Select>
                        : null
                }
                {
                    currentTab === "year" || currentTab === "month" ?
                        <Select
                            value={year}
                            onChange={(e) => handleMenuClick(e, "year")}
                            style={{ width: '100px' }}
                        >
                            {
                                yearList.map((value, index) => {
                                    return <Option key={index} value={value}>{value}</Option>;
                                })
                            }
                        </Select>
                        : null
                }
            </>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        translationCache: state.TranslationReducer.translationCache,
        currentTimeZone: state.LayoutReducer.currentTimeZone
    };
};

export default connect(mapStateToProps)(DayMonthYearSelection);
